/**
 * Created by fers on 26.09.15.
 */

import { v4 as uuidv4 } from 'uuid';
import { declareEntity } from '../fw/MetaDataHelper.ts';
import * as Permission from '../../common/util/Permission';

export default declareEntity({
    entity: "developerGroups",
    graphQL: "DeveloperGroup",
    name: "Developer",
    dynamoPrefix: 'org',
    storageType: 'schema',
    defaultTitle: (data) => {
        return data['name'];
    },
    writePermission: [
        Permission.PERM_EDIT_CHANNEL_DEF
    ],
    isPublic: true,
    defaultOrder: ['name'],
    fields: (types) => { return {
        id: {
            name: "Developer ID",
            type: "id",
            defaultValue: () => {
                return uuidv4();
            },
            primaryKey: true,
            required: true,
            userEditable: false,
            isPublic: true,
        },
        name: {
            name: "Developer name",
            type: "string",
            trim: true,
            defaultValue: "",
            required: true,
            translatable: true,
            isPublic: true,
        },
        externalId: {
            name: "External ID",
            type: "string",
            defaultValue: "",
            filterable: true,
        },
        shortName: {
            name: "Developer short name",
            type: "string",
            trim: true,
            defaultValue: "",
            translatable: true,
            isPublic: true,
        },
        logo: {
            name: "Logo",
            type: "string",
            isPublic: true,
        },
        web: {
            name: "Web",
            type: "string",
            defaultValue: "",
            translatable: true,
            isPublic: true,
        },
        support: {
            name: "Support",
            type: "string",
            defaultValue: "",
            translatable: true,
            isPublic: true,
        },
        description: {
            name: "Description",
            type: "text",
            defaultValue: "",
            translatable: true,
            isPublic: true,
        },
        updatedAt: {
            name: "Updated At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
        createdAt: {
            name: "Created At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
    }; },
    relations: (types) => { return {
        developerGroup2user: {
            type: 'manyToOne',
            to: types['developerGroup2users'],
            foreignKeys: [
                {
                    from: "id",
                    to: "developerGroup_id"
                }
            ]
        },
        channelDefs: {
            type: 'manyToOne',
            to: types['channelDefs'],
            isPublic: true,
            controllerFn: 'getChannelDefs',
        },
        publicChannelDefs: {
            type: 'manyToOne',
            to: types['channelDefs'],
            isPublic: true,
            controllerFn: 'getPublicChannelDefs',
        },
        flowDefs: {
            type: 'manyToOne',
            to: types['flowDefs'],
            isPublic: true,
            controllerFn: 'getFlowDefs',
        },
        addonDefs: {
            type: 'manyToOne',
            to: types['addonDefs'],
            isPublic: true,
            controllerFn: 'getAddonDefs',
        },
        scenarios: {
            type: 'manyToOne',
            to: types['scenarios'],
            isPublic: true,
            controllerFn: 'getScenariosDefs',
        },
        publicScenarios: {
            type: 'manyToOne',
            to: types['scenarios'],
            isPublic: true,
            controllerFn: 'getPublicScenarios',
        },
        scenarioDefs: {
            type: 'manyToOne',
            to: types['scenarioDefs'],
            isPublic: true,
            controllerFn: 'getScenarioDefs',
        },
        users: {
            type: 'manyToOne',
            to: types['users'],
            controllerFn: 'getDeveloperGroupUsers',
        },
    }; }
});
